import { createApp } from 'vue';
import App from './App.vue';
import 'lib-flexible/flexible.js';
import router from './router';
import '@/assets/styles/global.less';
// 引入 Vant 的全局样式
import 'vant/lib/index.css';

const app = createApp(App);

app.use(router).mount('#app');
